const x = {
  small: "16px",
  medium: "20px",
  large: "24px",
  xlarge: "32px"
};
export {
  x as Sizes
};
